import React from "react";
import { ChevronRight } from "lucide-react";
import { BRAND_ORANGE } from "./BaseLogo";

// Orange ">>>" chevron accent used beside section headings (brochure motif).
const Chevrons = ({ size = 22, count = 3, className = "" }) => (
  <span className={`inline-flex items-center ${className}`} aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <ChevronRight
        key={i}
        size={size}
        strokeWidth={3}
        style={{ color: BRAND_ORANGE, marginLeft: i === 0 ? 0 : -size * 0.42 }}
      />
    ))}
  </span>
);

export default Chevrons;
